import React, { Component } from "react";
import withFirebaseAuth from "react-with-firebase-auth";
import firebase from "firebase/app";
import Login from "../components/login/login";
import "firebase/auth";
import { firebaseApp, db } from "../components/utils/firestore";
import Edit from "../components/edit/edit";

const firebaseAppAuth = firebaseApp.auth();
const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
};

class Admin extends Component {
  constructor() {
    super();
    this.state = {
      signedIn: false,
    };
    this.authUser = this.authUser.bind(this);
  }

  updateSignedIn(val, onComplete = null) {
    this.setState(
      { signedIn: val },
      onComplete === null ? () => null : () => onComplete()
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.user !== prevProps.user) {
      this.authUser(
        this.props.user,
        this.updateSignedIn.bind(this),
        this.props.signOut
      );
    }
  }

  authUser(user, updater, signOut) {
    if (user == null) {
      return null;
    }
    let dbRef = db.collection("users");
    dbRef
      .where("email", "==", user.email)
      .get()
      .then(function (querySnapshot) {
        if (user.email !== "bisht81324@gapps.uwcsea.edu.sg") {
          updater(false, () => {
            signOut();
            window.alert(
              "Stop! You trying to sneak into my admin page? 😾"
            );
          });
        } else {
          updater(true);
        }
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  }

  logOut(signOut) {
    this.updateSignedIn(false, () => {
      signOut();
    });
  }

  render() {
    const { signInWithGoogle } = this.props;
    return (
      <div className="outer">
        {this.state.signedIn ? (
          <Edit />
        ) : (
          <Login signInWithGoogle={signInWithGoogle} />
        )}
      </div>
    );
  }
}

export default withFirebaseAuth({
  providers,
  firebaseAppAuth,
})(Admin);
